import { ReactNode } from "react";

type DynamicButtonProps = {
  layout: string,
  disabled?: boolean,
  children: ReactNode,
  active?: boolean,
  autoFocus?: boolean,
  onClick?: () => void
};

export const DynamicButton: React.FC<DynamicButtonProps> = props => {
  return (
    <button
      type="button"
      className={props.layout}
      onClick={props.onClick}
      disabled={props.disabled}
      autoFocus={props.autoFocus}
      >
      {props.children}
    </button>
  );
};
  